// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reject-reason[data-v-7fbe0e88]{display:-webkit-box;overflow:hidden;-webkit-line-clamp:4;-webkit-box-orient:vertical;word-break:break-all;text-overflow:ellipsis}[data-v-7fbe0e88] .g-tooltip .text{color:#fff}[data-v-7fbe0e88] .g-tooltip .text.-left{text-align:right!important}[data-v-7fbe0e88] .g-tooltip .text.-right{text-align:left!important}[data-v-7fbe0e88] .g-tooltip .text a{color:#fff;text-decoration:underline}", ""]);
// Exports
module.exports = exports;
